import React from "react";
import styled from "styled-components";
import Paragraph from "../components/Paragraph";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";

import abstractTom from "../images/abstract-tom.svg";

const Img = styled.img`
  display: block;
  width: 50%;
  margin: 0 auto 1rem auto;
`;

export default () => (
  <Col>
    <SubHeadline>
      WER BIN <Strong>ICH?</Strong>
    </SubHeadline>
    <Img src={abstractTom} />
    <Paragraph>
      Hallo! Mein Name ist Tom Raithel und ich programmiere seit über
      18 Jahren für das Web. Ich bin überzeugter „Clean Coder“, detailverliebt
      und ein Freund von durchdachten User Interfaces.
    </Paragraph>
    <Paragraph>
      Mein Fokus liegt in der Frontend-Entwicklung. D.h. in der Programmierung und technischen Konzeption von
      mittelgroßen bis komplexen Single Page Applikationen (SPA). 
    </Paragraph>
    <Paragraph>
      Code-Qualität, Architektur und Wartbarkeit 
      der Software stehen dabei für mich an erster Stelle.
    </Paragraph>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/Me.js